import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  inject,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { ProgressBarComponent } from "../../core/progress-bar/progress-bar.component";
import { MatSliderModule } from "@angular/material/slider";
import { CommonModule } from "@angular/common";
import { QuestionsService } from "../../core/services/questions.service";
import { AuthService } from "../../core/services/auth.service";
import { AuthUser } from "../../core/models/auth/auth.interface";
import { TestsService } from "../../core/services/tests.service";
import { UsersService } from "../../core/services/users.service";
import Swal from "sweetalert2";
import { User } from "../../core/models/user.interface";
import {
  DIMENSION_COLORS,
  QUESTION_STATUS,
  TEST_TYPES,
} from "../../core/shared/constants";
import { RangeComponent } from "../../core/shared/ui/range/range.component";
import { BaseComponent } from "../../core/shared/base.component";
import { LoaderService } from "../../core/shared/services/loader.service";
import { PolarChartComponent } from "../../core/shared/ui/polar-chart/polar-chart.component";
import { TutorialDialogComponent } from "../pages/tutorial-dialog/tutorial-dialog.component";

// declare var anychart: any

@Component({
  selector: "app-layout-assessment-future",
  standalone: true,
  imports: [
    ProgressBarComponent,
    MatSliderModule,
    CommonModule,
    RangeComponent,
    PolarChartComponent,
    TutorialDialogComponent,
  ],
  templateUrl: "./layout-assessment-future.component.html",
  styleUrl: "./layout-assessment-future.component.scss",
})
export class LayoutAssessmentFutureComponent
  extends BaseComponent
  implements AfterViewInit {
  @ViewChild("chart") chartElement!: ElementRef;
  @ViewChild("progressBarEspaciado") progressBarEspaciado!: ElementRef;
  @ViewChild("contentChart") contentChart!: ElementRef;
  @ViewChild("questionTextContainer") questionTextContainer!: ElementRef;
  @ViewChild("calification") calification!: ElementRef;

  isShowTutorial: boolean = false;
  tutorialSteps = [
    {
      title: "Navegador",
      description:
        "Lleva el control de tu progreso. En esta sección podrás ver el estado de tu recorrido y conocer en qué paso del proceso de autodescubrimiento te encuentras.",
    },
    {
      title: "Círculo de vida",
      description:
        "Realiza un análisis personal. Aquí podrás reflexionar sobre aspectos clave de tu vida y asignar una puntuación del 1 al 10 según tu nivel de satisfacción.",
    },
    {
      title: "Dimensiones",
      description:
        "Evalúa 8 áreas esenciales. Cada dimensión representa un aspecto importante de tu bienestar, dándote una visión completa para orientar tu desarrollo.",
    },
    {
      title: "Calificación",
      description:
        "Puntúa con precisión. Usa la barra de calificación para asignar fácilmente un valor a cada dimensión, visualizando tus prioridades y áreas de mejora.",
    },
  ];
  tutorialStep: number = 1;
  tutorialTitle!: string;
  tutorialDescription!: string;
  dialogPosition = { top: "0px", left: "0px" };
  dialogWidth = 350;
  dialogHeight = 280;

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.checkResponsive();
    if (this.isShowTutorial) {
      const dialogPosition = this.calculateDialogPosition(
        this.getElementToHighlight(this.tutorialStep),
        this.tutorialStep
      );
      this.dialogPosition = {
        top: dialogPosition.top,
        left: dialogPosition.left,
      };
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Verificar si la tecla presionada es Enter
    if (event.key === 'Enter') {
      // Prevenir el comportamiento por defecto
      event.preventDefault();
      
      // Solo ejecutar next() si el botón no está deshabilitado
      if (this.currentValue !== 0) {
        this.next();
      }
    }
  }

  private authService: AuthService = inject(AuthService);
  private loader = inject(LoaderService);
  authUser: AuthUser = this.authService.getAuthUser()!;
  user: User = this.authService.getUser()!;
  currentStep = 2;
  assessmentTypeId = 3;
  chart: any;
  series: number[] = [];
  dataSeries: any[] = [];
  currentQuestionIndex: number = 0;
  percentagem = 0;
  sliderValue: number = 50;
  currentValue: number = 5;
  dragging: boolean = false;
  questions: any[] = [];
  labels: any[] = [];
  isResponsive: boolean = false;
  isSliderMoved: boolean = false;

  // Valores del test "hoy" para comparar
  todayTestValues: { [key: string]: number } = {};

  colors = DIMENSION_COLORS;

  constructor(
    private router: Router,
    private questionsService: QuestionsService,
    private testService: TestsService,
    private usersService: UsersService
  ) {
    super();
  }

  async ngOnInit() {
    // this.chart = anychart.polar();
    // if(this.user.profile.onboardingComplete && this.user.profile.onboardingComplete === true) {
    //   this.router.navigate(['/dashboard']);
    //   return;
    // }
    await this.verifyNavigation();
    await this.getTodayTest(); // Obtener los valores del test "hoy" primero
    this.getTest();
  }

  ngAfterViewInit(): void {
    console.log("this.chart", this.chart);
  }

  async verifyNavigation() {
    this.authService.findUserById(this.authUser.id).subscribe({
      next: (res: any) => {
        this.user = res.data;
        if (
          this.user &&
          this.user.profile.onboardingComplete &&
          this.user.profile.onboardingComplete === true
        ) {
          this.router.navigate(["/dashboard"]);
          return;
        }
        if (this.user && !this.user.profile.testFutureComplete) {
          // Guarda una referencia al componente para usarla en el evento de clic
          const self = this;

          // Swal.fire({
          //   title:
          //     '<h2 style="font-size: 24px; margin-bottom: 20px;">Análisis del futuro</h2>',
          //   html: `
          //     <div style="text-align: left; padding: 0 15px;">
          //       <p style="margin-bottom: 15px; text-align: justify;">Ahora que has reflexionado sobre tu situación actual, 
          //       <strong>es momento de proyectarte hacia el futuro.</p>
          //       <p style="margin-bottom: 15px; text-align: justify;">Imagina cómo te gustaría que se vea tu vida en cada una de sus dimensiones más importantes. Visualiza ese escenario ideal y describe al menos cuatro dimensiones que consideres clave para tu bienestar y realización.</p>
          //       <p style="margin-bottom: 15px; text-align: justify;">Este ejercicio parte del supuesto de que tu futuro puede ser igual o mejor que tu presente. Si al hacerlo percibes un escenario poco favorable, conversa con tu mentor para diseñar un programa que te ayude a avanzar hacia una versión más positiva y deseada de tu futuro.</p>
          //       <p style="margin-top: 20px; font-size: 14px; color: #666;">Presiona "Siguiente" cuando estés listo para continuar.</p>
          //     </div>
          //   `,
          //   showConfirmButton: true,
          //   confirmButtonText: "Siguiente",
          //   confirmButtonColor: "#dc3545",
          //   showCancelButton: false,
          //   allowOutsideClick: false,
          //   customClass: {
          //     popup: "swal-future-popup",
          //     confirmButton: "swal-future-confirm-button",
          //     htmlContainer: "swal-future-html",
          //   },
          //   footer:
          //     '<a id="ver-tutorial-link" role="button" style="font-size: 14px; color: #000; cursor: pointer; text-decoration: none;">Ver tutorial</a>',
          //   didOpen: () => {
          //     // Usamos didOpen para asegurarnos de que el DOM esté listo
          //     const tutorialLink = document.getElementById("ver-tutorial-link");
          //     if (tutorialLink) {
          //       tutorialLink.onclick = function () {
          //         // Cierra el SweetAlert primero
          //         Swal.close();
          //         // Usa setTimeout para asegurar que el SweetAlert se cierre completamente antes de abrir el tutorial
          //         setTimeout(() => {
          //           self.changeShowTutorial();
          //         }, 100);
          //       };
          //     }
          //   },
          // });

          // Agregar estilos personalizados para el SweetAlert
          const style = document.createElement("style");
          style.innerHTML = `
            .swal-future-popup {
              border-radius: 15px !important;
              padding: 30px 20px !important;
              width: 450px !important;
              box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;
            }
            
            .swal-future-html {
              margin-top: 0 !important;
            }
            
            .swal-future-confirm-button {
              border-radius: 30px !important;
              min-width: 150px !important;
              font-weight: normal !important;
              box-shadow: none !important;
              background-color: #dc3545 !important;
            }
            
            .swal2-footer {
              border-top: none !important;
              text-align: center !important;
              padding-top: 0 !important;
            }
          `;
          document.head.appendChild(style);
        }
      },
    });
  }

  async getTest(): Promise<void> {
    this.loader.show();
    this.testService.find(this.authUser.id, TEST_TYPES.Futuro.id).subscribe({
      next: (res: any) => {
        if (res.data) this.initialize(res.data[0].questions);
        else this.listQuestions();
        this.loader.hide();
      },
      error: (err: any) => {
        console.log("err", err);
        this.loader.hide();
      },
    });
  }

  async listQuestions(): Promise<void> {
    this.loader.show();
    this.questionsService.find(this.assessmentTypeId).subscribe({
      next: (res: any) => {
        this.initialize(res.data);
        this.loader.hide();
      },
      error: (err: any) => {
        console.log("err", err);
        this.loader.hide();
      },
    });
  }

  private initialize(questions: any): void {
    this.questions = questions.sort((a: any, b: any) => a.order - b.order);
    this.questions.forEach((q) => {
      this.labels.push(q.dimension.name);
      q.answer = q.answer ?? {};
      this.series.push(
        q.answer && q.answer.value ? parseFloat(q.answer.value) : 0
      );
    });
    this.currentValue = this.series[0];
    if(this.series[this.series.length -1] > 0){
      this.currentValue = this.series[this.series.length -1];
      this.currentQuestionIndex = this.series.length -1;
      this.isSliderMoved = true
    }
    this.updateSingleDataPoint(this.currentQuestionIndex, this.currentValue);
    // this.createAnyChart();
  }

  updateTest(completed = false) {
    let test = {
      userId: this.authUser?.id ? this.authUser.id : "",
      userName: this.authUser?.name ? this.authUser.name : "",
      testTypeId: this.assessmentTypeId,
      question: {
        id: this.questions[this.currentQuestionIndex].id,
        title: this.questions[this.currentQuestionIndex].title,
        dimension: this.questions[this.currentQuestionIndex].dimension,
        status: QUESTION_STATUS.Contestado,
        answer: { value: this.currentValue.toString() },
      },
      completed: completed,
    };
    // this.loader.show();
    this.testService.updateTest(test).subscribe({
      next: async (res: any) => {
        if (res.data.completed) {
        }
        // this.loader.hide();
      },
      error: (err: any) => {
        console.log("err", err);
        // this.loader.hide();
      },
    });
  }

  updateTestCompleted() {
    let test = {
      userId: this.authUser?.id ? this.authUser.id : "",
      userName: this.authUser?.name ? this.authUser.name : "",
      testTypeId: this.assessmentTypeId,
      question: {
        id: this.questions[this.currentQuestionIndex].id,
        title: this.questions[this.currentQuestionIndex].title,
        dimension: this.questions[this.currentQuestionIndex].dimension,
        status: QUESTION_STATUS.Contestado,
        answer: { value: this.currentValue.toString() },
      },
      completed: true
    };
    
    this.loader.show();
    this.testService.updateTest(test).subscribe({
      next: async (res: any) => {
        this.loader.hide();
        // Mostrar modal de confirmación antes de navegar
        this.showCompletionModal();
      },
      error: (err: any) => {
        console.log('err', err);
        this.loader.hide();
        // En caso de error, también mostrar el modal
        this.showCompletionModal();
      }
    });
  }

  showCompletionModal() {
    Swal.fire({
      title: '',
      html: `
        <div style="text-align: center; padding: 0;">
          <!-- Imagen superior -->
          <div style="margin-bottom: 30px;">
            <img src="assets/img/office-meeting.jpg" 
                 alt="Completaste tu presente" 
                 style="width: 100%; height: 200px; object-fit: cover; border-radius: 15px 15px 0 0;" />
          </div>
          
          <!-- Título -->
          <h2 style="font-size: 28px; margin: 0 0 20px 0; color: #2c3e50; font-weight: 700; text-align: center; line-height: normal;">
            ¡Felicidades, completaste tu futuro!
          </h2>
          
          <!-- Texto descriptivo -->
          <div style="padding: 0 20px 30px 20px;">
            <p style="font-size: 16px; color: #495057; line-height: 1.6; margin: 0; text-align: justify;">
              ¡Listo! Ya completaste tu futuro. Ahora es momento evaluar tus respuestas y entregarte un diagnóstico personalizado.
            </p>
          </div>
        </div>
      `,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Ver diagnóstico',
      cancelButtonText: 'Revisar respuestas',
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      reverseButtons: true,
      allowOutsideClick: false,
      customClass: {
        popup: 'completion-modal-popup',
        confirmButton: 'completion-modal-confirm-button',
        cancelButton: 'completion-modal-cancel-button',
        title: 'completion-modal-title',
        htmlContainer: 'completion-modal-html'
      },
      didOpen: () => {
        // Agregar estilos personalizados para el modal
        const style = document.createElement('style');
        style.innerHTML = `
          .completion-modal-popup {
            border-radius: 20px !important;
            width: 90% !important;
            max-width: 550px !important;
            min-width: 300px !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.15) !important;
            border: 1px solid #e9ecef !important;
            margin: 20px !important;
          }
          
          .completion-modal-title {
            padding: 0 !important;
            margin-bottom: 20px !important;
          }
          
          .completion-modal-html {
            margin: 0 !important;
          }
          
          .completion-modal-confirm-button {
            border-radius: 10px !important;
            min-width: 140px !important;
            font-weight: 600 !important;
            font-size: 16px !important;
            padding: 12px 30px !important;
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3) !important;
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
            border: none !important;
            transition: all 0.3s ease !important;
            width: 45% !important;
          }
          
          .completion-modal-confirm-button:hover {
            transform: translateY(-2px) !important;
            box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4) !important;
          }
          
          .completion-modal-cancel-button {
            border-radius: 10px !important;
            min-width: 140px !important;
            font-weight: 600 !important;
            font-size: 16px !important;
            padding: 12px 30px !important;
            background: #fff !important;
            color: #dc3545 !important;
            border: 2px solid #E0E4EA !important;
            transition: all 0.3s ease !important;
            width: 45% !important;
          }
          
          .completion-modal-cancel-button:hover {
            background: #dc3545 !important;
            border: 2px solid #dc3545 !important;
            color: #fff !important;
            transform: translateY(-2px) !important;
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3) !important;
          }
          
          .swal2-actions {
            gap: 15px !important;
            margin-top: 25px !important;
            padding: 0 20px 20px 20px !important;
            flex-wrap: wrap !important;
            justify-content: center !important;
          }
          
          /* Responsive para tablets */
          @media (max-width: 768px) {
            .completion-modal-popup {
              width: 95% !important;
              max-width: 400px !important;
              margin: 15px !important;
              border-radius: 15px !important;
            }
            
            .completion-modal-confirm-button,
            .completion-modal-cancel-button {
              min-width: 120px !important;
              font-size: 15px !important;
              padding: 11px 25px !important;
              width: 100% !important;
            }
            
            .swal2-actions {
              gap: 12px !important;
              padding: 0 15px 15px 15px !important;
              flex-direction: column-reverse !important;
            }
          }
          
          /* Responsive para móviles */
          @media (max-width: 480px) {
            .completion-modal-popup {
              width: 95% !important;
              max-width: 320px !important;
              margin: 10px !important;
              border-radius: 12px !important;
            }
            
            .completion-modal-confirm-button,
            .completion-modal-cancel-button {
              width: 100% !important;
              min-width: unset !important;
              font-size: 14px !important;
              padding: 12px 20px !important;
              margin: 0 !important;
              width: 100% !important;
            }
            
            .swal2-actions {
              flex-direction: column !important;
              gap: 10px !important;
              padding: 0 15px 15px 15px !important;
              flex-direction: column-reverse !important;
            }
            
            /* Ajustar imagen en móviles */
            .completion-modal-popup img {
              height: 150px !important;
              border-radius: 12px 12px 0 0 !important;
              display: none;
            }
            
            /* Ajustar texto en móviles */
            .completion-modal-popup h2 {
              font-size: 24px !important;
              margin: 0 0 15px 0 !important;
              padding: 0 10px !important;
            }
            
            .completion-modal-popup p {
              font-size: 14px !important;
              padding: 0 15px 20px 15px !important;
            }
          }
          
          /* Responsive para pantallas muy pequeñas */
          @media (max-width: 360px) {
            .completion-modal-popup {
              width: 98% !important;
              margin: 5px !important;
            }
            
            .completion-modal-popup h2 {
              font-size: 22px !important;
            }
            
            .completion-modal-popup p {
              font-size: 13px !important;
            }
          }
        `;
        document.head.appendChild(style);
      }
    }).then((result) => {
      if (result.isConfirmed) {
        // Botón "Continuar" - navegar al diagnóstico
        this.router.navigate(['/results']);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // Botón "Revisar respuestas" - volver a la primera pregunta
        this.currentQuestionIndex = 0;
        this.currentValue = this.questions[0].answer.value ?? 0;
        this.actualizarPorcentaje();
      }
    });
  }

  private checkResponsive() {
    this.isResponsive = window.innerWidth <= 768;
  }

  // Verificar si el valor proyectado es menor que el valor actual
  validateProjectedValue(): boolean {
    const currentQuestionDimensionId =
      this.questions[this.currentQuestionIndex].dimension.id;
    const todayValue = this.todayTestValues[currentQuestionDimensionId];
    let isInvalid = false;

    // Si el valor de hoy es 10, el futuro puede ser 10, pero no menor.
    if (todayValue === 10) {
      if (this.currentValue < todayValue) {
        isInvalid = true;
      }
    } else {
      // Si el valor de hoy es menor a 10, el futuro debe ser estrictamente mayor.
      if (this.currentValue <= todayValue) {
        isInvalid = true;
      }
    }

    if (isInvalid) {
      Swal.fire({
        icon: "warning",
        title: `Valor no válido`,
        text: `El valor proyectado (${this.currentValue}) debe ser mayor que el valor actual (${todayValue}).`,
        confirmButtonText: "Entendido",
        confirmButtonColor: "#dc3545",
        didOpen: () => {
          const title = Swal.getTitle();
          const content = Swal.getHtmlContainer();
          if (title) {
            title.style.fontSize = "1.2rem";
          }
          if (content) {
            content.style.fontSize = "1rem";
          }
        },
      });
      return false;
    }

    return true;
  }

  next() {
    if (this.currentValue == 0) {
      this.alert("Debe contestar la pregunta con un valores entre 1-10", "");
      return;
    }

    // Validar que el valor proyectado no sea menor que el actual
    if (!this.validateProjectedValue()) {
      return;
    }

    // Actualizar la pregunta actual
    this.updateSingleDataPoint(this.currentQuestionIndex, this.currentValue);
    this.questions[this.currentQuestionIndex].answer.value = this.currentValue;
    
    if (this.currentQuestionIndex < this.questions.length - 1) {
      // Ir a la siguiente pregunta
      this.currentQuestionIndex++;
      this.currentValue = this.questions[this.currentQuestionIndex].answer.value ?? 0;
      this.actualizarPorcentaje();
      this.updateTest();
    } else {
      // Es la última pregunta, completar el test y mostrar modal
      this.updateTestCompleted();
    }
  }

  previous() {
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
      this.isSliderMoved = false; // Reset on previous question
      this.currentValue =
        this.questions[this.currentQuestionIndex].answer.value ?? 0;
      this.updateSingleDataPoint(this.currentQuestionIndex, this.currentValue);
    }
  }

  changeRange(value: number) {
    this.currentValue = value;
    this.questions[this.currentQuestionIndex].answer.value = this.currentValue;
    this.updateSingleDataPoint(this.currentQuestionIndex, this.currentValue);
    this.isSliderMoved = true; // Set to true on slider interaction
    this.updateTest();
  }

  preguntasRespondidas(): boolean {
    return (
      this.questions.filter((q) => q.answer && q.answer.value > 0).length > 3
    );
  }

  actualizarPorcentaje() {
    this.percentagem = Math.floor(
      (this.currentQuestionIndex / (this.questions.length - 1)) * 100
    );
  }

  refreshDataSeries() {
    this.dataSeries = [];
    for (let i = 0; i < this.series.length; i++) {
      this.dataSeries.push({
        x: this.labels[i],
        value: this.series[i],
        fill: this.colors[i],
      });
    }
    // console.log('this.dataSeries ', this.dataSeries);
  }

  // createAnyChart() {

  //   this.chart = anychart.polar();

  //   this.refreshDataSeries();
  //   let column = this.chart.column(this.dataSeries);
  //   column.stroke({ thickness: 0 });

  //   this.chart.yAxis(true);
  //   this.chart.xScale('ordinal');
  //   var scale = this.chart.yScale();
  //   scale.maximum(10);
  //   scale.minimum(0);
  //   scale.ticks().interval(1);
  //   this.chart.container(this.chartElement.nativeElement);
  //   this.chart.draw();

  // }

  updateSingleDataPoint(index: number, newValue: number) {
    // if (this.chart) {
    this.series[index] = newValue;
    // this.chart.removeAllSeries();
    this.refreshDataSeries();
    // const column = this.chart.column(this.dataSeries);
    // column.stroke({ thickness: 0 });
    // }
  }

  async send() {
    // Validar que el valor proyectado no sea menor que el actual antes de enviar
    if (!this.validateProjectedValue()) {
      return;
    }

    this.updateTest(true);
    this.router.navigate(["/results"]);
  }

  isLastQuestion(): boolean {
    return this.currentQuestionIndex === this.questions.length - 1;
  }

  changeShowTutorial() {
    this.tutorialStep = 1;
    this.updateTutorialContent();
    this.isShowTutorial = !this.isShowTutorial;
    if (this.isShowTutorial === false) this.clearPreviousFocus();
  }

  resetTutorial() {
    this.tutorialStep = 1;
    this.updateTutorialContent();
  }

  nextStepTutorial() {
    if (this.tutorialStep < this.tutorialSteps.length) {
      this.tutorialStep++;
      this.updateTutorialContent();
    } else {
      this.clearPreviousFocus();
      this.isShowTutorial = false;
    }
  }

  private updateTutorialContent() {
    this.tutorialTitle = this.tutorialSteps[this.tutorialStep - 1].title;
    this.tutorialDescription =
      this.tutorialSteps[this.tutorialStep - 1].description;
    this.showTutorialDialog(this.getElementToHighlight(this.tutorialStep));
  }

  getElementToHighlight(option: number): ElementRef {
    switch (option) {
      case 1:
        return this.progressBarEspaciado;
      case 2:
        return this.contentChart;
      case 3:
        return this.questionTextContainer;
      case 4:
        return this.calification;
      default:
        return this.progressBarEspaciado;
    }
  }

  showTutorialDialog(targetElement: ElementRef) {
    targetElement.nativeElement.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });

    const dialogPosition = this.calculateDialogPosition(
      targetElement,
      this.tutorialStep
    );
    this.dialogPosition = {
      top: dialogPosition.top,
      left: dialogPosition.left,
    };
    this.clearPreviousFocus();
    targetElement.nativeElement.classList.add("tutorial-focus");
  }

  clearPreviousFocus() {
    document.querySelectorAll(".tutorial-focus").forEach((element) => {
      element.classList.remove("tutorial-focus");
    });
  }

  private calculateDialogPosition(
    targetElement: ElementRef,
    stepNumber: number
  ): { top: string; left: string } {
    const elementRect = targetElement.nativeElement.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    const targetCenterX = elementRect.left + elementRect.width / 2;
    const targetCenterY = elementRect.top + elementRect.height / 2;
    const centerX = viewportWidth / 2;
    const centerY = viewportHeight / 2;

    let dialogLeft, dialogTop;
    const padding = 20;
    if (stepNumber > 2) {
      dialogLeft =
        elementRect.left + (elementRect.width - this.dialogWidth) / 2;
      dialogTop = elementRect.top - this.dialogHeight - padding;
    } else {
      dialogLeft = (targetCenterX + centerX) / 2 - this.dialogWidth / 2;
      dialogTop = (targetCenterY + centerY) / 2 - this.dialogHeight / 2;
    }

    const overlapThreshold = this.dialogHeight / 2;
    if (dialogTop + this.dialogHeight > elementRect.top + overlapThreshold) {
      dialogTop = elementRect.top + elementRect.height + padding;
    }

    const left = Math.min(
      Math.max(dialogLeft, 0),
      viewportWidth - this.dialogWidth
    );
    const top = Math.min(
      Math.max(dialogTop, 0),
      viewportHeight - this.dialogHeight
    );

    return {
      top: `${top}px`,
      left: `${left}px`,
    };
  }

  // Método para fragmentar preguntas
  splitQuestions(questionText: string): string[] {
    if (!questionText) return [];
    // Divide el texto en preguntas individuales
    return questionText
      .split("¿")
      .map((q) => q.trim())
      .filter((q) => q.length > 0)
      .map((q) => `¿${q}${q.endsWith("?") ? "" : "?"}`);
  }

  async getTodayTest(): Promise<void> {
    this.loader.show();
    this.testService.find(this.authUser.id, TEST_TYPES.Hoy.id).subscribe({
      next: (res: any) => {
        if (res.data && res.data.length > 0) {
          // Guardar los valores de las preguntas del test "hoy" para compararlos después
          const todayQuestions = res.data[0].questions;
          todayQuestions.forEach((q: any) => {
            if (q.answer && q.answer.value) {
              this.todayTestValues[q.dimension.id] = parseFloat(q.answer.value);
            }
          });
        }
        this.loader.hide();
      },
      error: (err: any) => {
        console.log("Error al obtener el test de hoy:", err);
        this.loader.hide();
      },
    });
  }
}
